// Data (aaaa-mm-dd) pelo relogio do computador. toISOString() da a data em UTC:
// depois das 21h em Brasilia ja e o dia seguinte.
export function dataLocalISO(d: Date = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}
